import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import "./screen-container.scss";
export const ScreenContainer = ({ children }) => {
    return _jsx("div", { className: "screen-container", children: children });
};
